import { CommonModule } from '@angular/common';
import { Component, model, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GetDataService } from '../../../services/userService/get-data.service';
import { AuthServiceService } from '../../../services/auth-service.service';
import { showCustomeAlert } from '../../../services/Alert/alert.service';
import { LoaderComponent } from '../../../Common/loader/loader.component';
@Component({
  selector: 'app-set-configurations',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule,LoaderComponent],
  templateUrl: './set-configurations.component.html',
  styleUrl: './set-configurations.component.scss'
})
export class SetConfigurationsComponent implements OnInit {
  UserDEtails : any;
  isLoading:boolean=false;
  constructor(private _service: GetDataService,private _authService : AuthServiceService) { }
  Configurations: any[] = [];
  ngOnInit(): void {
    this.isLoading = true;
    this.UserDEtails = this._authService.getUserSession();
    this._service.getConfiguration().subscribe((res) => {
      this.Configurations = res;
      this.isLoading = false;
    });
  }

  ConfigForm = new FormGroup({
    id: new FormControl(0, [
      Validators.required,
    ]),
    flagName: new FormControl("", [
      Validators.required,
    ]),
    value: new FormControl("", [
      Validators.required,
    ]),
    isActive: new FormControl(false, [
      Validators.required,
    ]),
  })

  onSubmit() {
    if (this.ConfigForm.valid) {
      const { flagName,value, isActive } = this.ConfigForm.value;
      if (this.ConfigForm.value.id == 0 || this.ConfigForm.value.id == null || this.ConfigForm.value.id == undefined) {
        this._service.addConfiguration({ flagName, value, isActive }).subscribe((res) => {
          this.ConfigForm.reset();
          this.ngOnInit();
        },
          (err) => {
              showCustomeAlert("error","Something went wrong..","Error");
          }
        )
      }else{
        this._service.updateConfiguration({flagName,value,isActive},this.ConfigForm.value.id).subscribe((res)=>{
          this.ConfigForm.reset();
          this.ngOnInit();
        },(err)=>{
          showCustomeAlert("error","Something went wrong..","Error");
        })
      }
    }
  }

  onEditClick(configuration: any) {
    this.ConfigForm.patchValue({
      id : configuration.id,
      flagName: configuration.flagName,
      value: configuration.value,
      isActive: configuration.isActive,
    })
  }

  onActive(configuration:any){
    this.ConfigForm.patchValue({
      id : configuration.id,
      flagName: configuration.flagName,
      value: configuration.value,
      isActive: !configuration.isActive,
    })
    this.onSubmit();
  }
}
